import { storyblokEditable } from "@storyblok/react/rsc";

import { ListItemIcon, type ListItemIconName } from "@/components/icons";
import { RichTextField } from "@/components/typography/RichTextField";

import type { AssetStoryblok } from "@/component-types-sb";

type InfoCardStoryblok = {
  icon: ListItemIconName;
  custom_icon?: AssetStoryblok;
  text: string;
  _uid: string;
  component: "info_card";
  [k: string]: any;
};

type InfoCardProps = {
  blok: InfoCardStoryblok;
};

const InfoCard = ({ blok }: InfoCardProps) => {
  return (
    <div
      className="col-span-12 md:col-span-4 bg-white rounded-3xl p-6 flex flex-col items-center gap-4"
      {...storyblokEditable(blok)}
    >
      {(blok.custom_icon?.filename || blok.icon) && (
        <div className="rounded-full bg-sand-50 p-3">
          {blok.custom_icon?.filename ? (
            <img src={blok.custom_icon.filename} alt="" className="size-6" />
          ) : (
            <ListItemIcon name={blok.icon} className="size-6" />
          )}
        </div>
      )}
      {blok.text && (
        <RichTextField value={blok.text} className="text-copy text-black text-center" />
      )}
    </div>
  );
};

export default InfoCard;
